import React, { FC, useEffect, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import styles from './user-button.module.scss'
import { useAppSelector } from "../../../hooks/useAppSelector";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../hooks/useAppDispatch";
import { logout } from "../../../services/actions/user";

const UserButton: FC = () => {    
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const { t } = useTranslation();
    const { user } = useAppSelector(state => state.user);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const toggleCard = () => {
        if (!user) {
            navigate('/login');
            return;
        }
        setIsOpen(prev => !prev);
    };

    const ref = useRef<HTMLDivElement | null>(null);
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent | Event) => {
            if (ref.current && !ref.current.contains(event.target as Node)) {
            setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleClickLogout = () => {
        setIsOpen(false);
        dispatch(logout());
    };

    return (
        <div className={styles.userButton} ref={ref}>
            <button onClick={toggleCard} className={isOpen ? styles.open : ''}>
                <div className={styles.user}>
                    <div className={styles.account}/>
                    {user ? user.userName: t('user-button.login')}
                </div>
                {user && <div className={styles.chevron}/>}
            </button>
            {
                isOpen && <div className={styles.popup}>
                    <button onClick={() => handleClickLogout()}  className={styles.logout}>
                        {t('user-button.logout')}
                        <div/>
                    </button>
                </div>
            }
            
            </div>
    )
}

export default UserButton
